import tw from "tailwind-styled-components";
import { FaRupeeSign, FaRegCalendar } from "react-icons/fa";
import { FaRegClock } from "react-icons/fa6";

export const InputGroup = tw.div`w-full flex flex-col md:space-y-1.5 space-y-1 mt-2 md:mt-0`;

export const CombineInputGroup = tw.div`w-full flex md:flex-row flex-col space-x-4 items-end`;
export const combineLabelInput = tw.div`grid md:grid-cols-2 grid-cols-1`
export const FieldWrapper = tw.div`
${(p) => (p.$select ? "h-10" : "pl-2   field-wrapper border border-gray-300")}
 relative  rounded-md  w-full  flex items-center`;
export const FieldWrappers = tw.div`pl-2 relative  rounded-md  w-full  flex items-center border border-gray-300 h-10`;
// export const Label = tw.label`text-sm text-gray-500 font-normal`;

export const Label = tw.label`text-sm text-gray-500 font-normal`;
export const ModalHeading = tw.h2` font-semibold mt-0`;
export const ModalSubHeading = tw.h4`text-sm text-gray-500 font-normal mt-4`;
export const ModalLabel = tw.h4`text-base text-gray-700 font-medium`;

export const WrapperHeading = tw.h2`mt-4`;
export const FormContainer = tw.div` grid max-w-2xl gap-5 md:gap-7 mt-4`;

export const FormContainerVertical = tw.div` grid  gap-5 md:gap-7 mt-4`;

export const SubmitBtn = tw.button`
text-sm  w-32   md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed   md:text-base bg-primary-color hover:bg-hover-color text-white rounded-md shadow-md`;

export const PreviewBtn = tw.button`
text-sm  w-32  md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed   md:text-base bg-cyan-100 hover:bg-cyan-200 text-cyan-700 rounded-md shadow-md`;

export const OtherBtn = tw.button`
  text-sm  w-32  md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed   md:text-base bg-green-100 hover:bg-green-200 text-gray-600 rounded-md shadow-md`;

export const PrevBtn = tw.button`
  text-sm  w-32  md:w-32 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed   md:text-base bg-gray-200 hover:bg-gray-100 text-gray-600 rounded-md shadow-md`;

export const SaveBtn = tw.button`
  text-sm  w-32  md:w-32 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed   md:text-base bg-cyan-100 hover:bg-cyan-200 text-cyan-700 rounded-md shadow-md`;

export const SmallBtn = tw.button`
  whitespace-nowrap text-xs px-4 py-2 sm:px-6 sm:py-2.5 rounded-md bg-white-400  cursor-pointer hover:bg-gray-200 shadow border transition duration-200 text-gray-600 sm:text-sm`;

export const SideCancelBtn = tw.button`
  text-sm  w-32  md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed   md:text-base  text-gray-600 `;

export const CancelBtn = tw.button`
  text-sm  w-32  md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed   md:text-base bg-gray-100 hover:bg-gray-200 text-gray-600 rounded-md shadow-md`;
export const CardWrapper = tw.div`flex md:gap-4 gap-2 my-1.5`;
export const SelectionCard = tw.button`flex flex-col items-center justify-center py-2 px-8 border rounded-full shadow-sm cursor-pointer`;
export const OptionText = tw.span`text-sm text-gray-600`;
export const Summary = tw.div``;
export const SummaryTitle = tw.h3` font-semibold mb-1`;
export const SummaryRow = tw.div`flex justify-between items-center my-1`;
export const SummaryLabel = tw.span`text-sm text-gray-600`;
export const SummaryValue = tw.span`text-sm font-semibold`;
export const Wrapper = tw.div`grid gap-4 mt-4 overflow-y-auto`;
export const ActionSection = tw.div`px-4 py-2 bg-white flex justify-between border-t border-gray-200 absolute bottom-0 left-0 w-full`;
export const ScrollableContent = tw.div`flex-grow overflow-y-auto max-h-[calc(100vh-200px)] custom-scrollbar mb-10`;
export const RupeeIcon = tw(FaRupeeSign)`
  absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-3 h-3
`;
export const CalendarIcon = tw(FaRegCalendar)`
  absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-3 h-3
`;
export const ClockIcon = tw(FaRegClock)`
  absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-3 h-3
`;
export const Note = tw.p`text-xs text-gray-400 flex`;
